import React from 'react'

export default function FilterIcon() {
  return (
   <>
   <img src='/dashboardimages/Group 8922 (1).png'/>
   </>
  )
}
